import { render, staticRenderFns } from "./ManageNoticeList.vue?vue&type=template&id=0c306aa0&scoped=true&lang=pug&"
import script from "./ManageNoticeList.vue?vue&type=script&lang=ts&"
export * from "./ManageNoticeList.vue?vue&type=script&lang=ts&"
import style0 from "./ManageNoticeList.vue?vue&type=style&index=0&id=0c306aa0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c306aa0",
  null
  
)

export default component.exports